import {z} from 'zod';

const textCellSchema = z.object({value: z.string().nullable()});
const labelCellSchema = z.object({value: z.object({label: z.string().nullable()}).nullable()});

export const tireSetRequestPdfCellsSchema = z.object({
  setNumber: textCellSchema,
  requestHomeBranch: labelCellSchema,
  storageWarehouse: labelCellSchema,
  storageLocation: textCellSchema,
  wheelNumber: z.object({value: z.number().int().nonnegative().nullable()}),
  neededAt: z.object({
    value: z
      .string()
      .trim()
      .pipe(z.union([z.literal(''), z.string().date(), z.string().datetime({offset: true})]))
      .nullable(),
  }),
  requestType: labelCellSchema,
  requestState: labelCellSchema,
  requestDestinationBranch: labelCellSchema,
  wheelState: labelCellSchema,
  tireManufacturer: textCellSchema,
  tireCategory: labelCellSchema,
  tireSeason: textCellSchema,
  tireWheel: textCellSchema,
});
